import React from 'react';
import { Switch } from '@headlessui/react';
import { Store } from 'lucide-react';

export function BusinessHeader({ 
  business, 
  isOnline = false,
  onToggleOnline,
  className = ''
}) {
  return (
    <div className={`flex items-center justify-between p-4 bg-white dark:bg-gray-800 ${className}`}>
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center overflow-hidden">
          {business?.image ? (
            <img 
              src={business.image} 
              alt={business.name} 
              className="w-full h-full object-cover"
            />
          ) : (
            <Store className="w-6 h-6 text-gray-400" />
          )}
        </div>
        <div>
          <h2 className="text-lg font-semibold dark:text-white">
            {business?.name || 'Tu Negocio'}
          </h2>
          {isOnline && (
            <span className="text-sm text-green-600 font-medium">
              Visible
            </span>
          )}
        </div>
      </div>
      
      {onToggleOnline && (
        <Switch
          checked={isOnline}
          onChange={onToggleOnline}
          className={`${
            isOnline ? 'bg-green-500' : 'bg-gray-200 dark:bg-gray-700'
          } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none`}
        >
          <span className="sr-only">Activar catálogo</span>
          <span
            className={`${
              isOnline ? 'translate-x-6' : 'translate-x-1'
            } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
          />
        </Switch>
      )}
    </div>
  );
} 